import React, { useEffect, useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Defaultaddress from '../../User/components/Default_address';
import { useNavigate } from 'react-router-dom';
import instance from '../../Utils/api';
import Loading from '../assets/loader.svg';
import AddIcon from '@mui/icons-material/Add';


const Address = () => {
  const navigate = useNavigate();
  const [addresses, setAddresses] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);

  const getAddressData = async () => {
    try {
      const response = await instance.get('Address/getAddress');
      setAddresses(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getAddressData();
  }, []);

  return (
    <React.Fragment>
      {loading === true ?
        <Stack className='loader'>
          <img src={Loading} alt='loader' />
        </Stack>
        :
        <section className='address'>
          <div className='address-title'>
            <Typography variant='h4'>Address</Typography>
            {/* <Button onClick={() => navigate('/profile/addadress')}>Edit<img src={address_edit} alt='address_edit' /> </Button> */}
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => navigate('/profile/addadress')}
              sx={{
                borderRadius: '33px',
                fontFamily: '"Poppins", sans-serif',
                fontWeight: 700,
                padding: '12px 24px',
                textTransform: 'capitalize',
                backgroundColor: '#032a4b',
                '&:hover': {
                  backgroundColor: '#021e35' 
                }
              }}
            >
              Add Address
            </Button>
          </div>
          <>
            {addresses?.length >= 1 ?
              <Grid container spacing={3} rowSpacing={3} alignItems="stretch" >
                {addresses?.length ? addresses.map((data) => (
                  <Grid size={{ sm: 12, xs: 12, md: 6, lg: 4 }} >
                    <Defaultaddress
                      data={data}
                      selectedId={selectedId}
                      onSelect={setSelectedId}
                    />
                  </Grid>)) : null}
              </Grid> :
              <Typography variant="body1" color="error" fontWeight={500}>
                No address found. Please add your address to continue.
              </Typography>
            }
          </>
        </section>}
    </React.Fragment>
  )
}

export default Address